import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";

toast.configure();

const updateRealokasi = async (axiosInstance, id, formData) => {
  return await axiosInstance.put(`realokasi/${id}`, formData).catch((error) => {
    console.error(error);
    toast.error(`PUT (Realokasi) ${error.message}`, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: timeToast,
    });
  });
};

export default updateRealokasi;
